

export default function About() {
    return (
        <div>

            <div className="w3-content w3-margin-top" style={{ maxWidth: '1400px' }}>
                <div className="w3-row-padding">
                    <div className="w3-third">
                        <div className="w3-white w3-text-grey w3-card-4">
                            <div className="w3-display-container mt-3">
                                <img src={"assets/images/ameer_ali.jpg"} style={{
                                    width: '100%'
                                }} alt="Avatar" />
                                <div className="w3-display-bottomleft w3-container w3-text-black">
                                    <h2>Ameer Ali Jamali</h2>
                                </div>
                            </div>
                            <div className="w3-container mt-3">
                                <p><i className="fa fa-briefcase fa-fw w3-margin-right w3-large w3-text-teal"></i>Full Stack Web Developer</p>
                                <p><i className="fa fa-home fa-fw w3-margin-right w3-large w3-text-teal"></i>Pakistan,Karachi</p>
                                <p><i className="fa fa-envelope fa-fw w3-margin-right w3-large w3-text-teal"></i>ameer.ali.jamali886@gmail.com</p>
                                <p><i className="fa fa-phone fa-fw w3-margin-right w3-large w3-text-teal"></i>+92768768555</p>
                                <hr />


                                <p className="w3-large"><b><i className="fa fa-asterisk fa-fw w3-margin-right w3-text-teal"></i>Skills</b>
                                </p>
                                <hr />
                                <p>Html5 | Css | Bootstrap | Tailwind-Css </p>
                                <div className="w3-light-grey w3-round-xlarge w3-small">
                                    <div className="w3-container w3-center w3-round-xlarge w3-teal" style={{
                                        width: '99%'
                                    }}>99.99%</div>
                                </div>
                                <p className="mt-2">Javascript | Jquery | Ajax </p>
                                <div className="w3-light-grey w3-round-xlarge w3-small">
                                    <div className="w3-container w3-center w3-round-xlarge w3-teal" style={{
                                        width: '99.99%'
                                    }}>
                                        <div className="w3-center w3-text-white">99.99%</div>
                                    </div>
                                </div>
                                <p className="mt-2">Php | Laravel | Mvc</p>
                                <div className="w3-light-grey w3-round-xlarge w3-small">
                                    <div className="w3-container w3-center w3-round-xlarge w3-teal" style={{
                                        width: '99.99%'
                                    }}>99.99%</div>
                                </div>
                                <p className="mt-2">React.js</p>
                                <div className="w3-light-grey w3-round-xlarge w3-small">
                                    <div className="w3-container w3-center w3-round-xlarge w3-teal" style={{
                                        width: '69.99%'
                                    }}>69.99%</div>
                                </div>
                                <p className="mt-2">Node.js | C# | .Net </p>
                                <div className="w3-light-grey w3-round-xlarge w3-small">
                                    <div className="w3-container w3-center w3-round-xlarge w3-teal" style={{ width: '40%' }}>40%</div>
                                </div>
                                <br />
                                <hr />
                                <p className="w3-large w3-text-theme"><b><i
                                    className="fa fa-globe fa-fw w3-margin-right w3-text-teal"></i>Languages</b></p>
                                <hr />
                                <p className="mt-3">English</p>
                                <div className="w3-light-grey w3-round-xlarge">
                                    <div className="w3-round-xlarge w3-teal" style={{
                                        height: '22px',
                                        width: '99%'
                                    }}></div>
                                </div>
                                <p className="mt-3">Urdu</p>
                                <div className="w3-light-grey w3-round-xlarge">
                                    <div className="w3-round-xlarge w3-teal" style={{
                                        height: '22px',
                                        width: '100%'
                                    }}></div>
                                </div>
                                <p className="mt-3">Arabic</p>
                                <div className="w3-light-grey w3-round-xlarge">
                                    <div className="w3-round-xlarge w3-teal" style={{
                                        height: '22px',
                                        width: '80%'
                                    }}></div>
                                </div>

                                <br />
                            </div>
                        </div><br />

                    </div>

                    <div className="w3-twothird">

                        <div className="w3-container w3-card w3-white w3-margin-bottom mt-3">
                            <h2 className="w3-text-grey w3-padding-16"><i
                                className="fa fa-suitcase fa-fw w3-margin-right w3-xxlarge w3-text-teal"></i>Work Experience
                            </h2>
                            <div className="w3-container">
                                <h5 className="w3-opacity"><a href="https://github.com/ameer-ali-jamali/E_Project_Using_Laravel"><b>Full Stack Development / E-Books.com</b></a></h5>
                                <h6 className="w3-text-teal mt-2"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Jan 2023</h6>
                                <p className="mt-3">E-Books is a free platform to access public book content. It has a admin dashboard through which an admin can manage users and books.</p>
                                <hr />
                            </div>
                            <div className="w3-container">
                                <h5 className="w3-opacity"> <a href="https://github.com/ameer-ali-jamali/Assignment-22-E-Project-Web-Designing-Using-Html-Css"><b>Frontend Development / A1-Uniforms.com</b></a></h5>
                                <h6 className="w3-text-teal"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Mar 2012 - Dec 2014
                                </h6>
                                <p className="mt-3">A simple Frontend Website Where user can see products and products details also.
                                    This project is inspired by ExportLeftOvers Pakistan
                                    (ELO).
                                    Developed the solution using HTML, CSS, Bootstrap, Javascript, and jQuery.</p>
                                <hr />
                            </div>
                            <div className="w3-container">
                                <h5 className="w3-opacity"><b>React.js / Temp-Details.com</b></h5>
                                <h6 className="w3-text-teal"><i className="fa fa-calendar fa-fw w3-margin-right"></i>Feb 2023
                                </h6>
                                <p className="mt-3">The purpose of a temporary details website is to provide timely and relevant information to a specific audience. It can be a useful tool for organizations and businesses to communicate updates, news, and important details to the public. After the event or project has been completed, the website may be taken down or repurposed for another use.</p><br />
                            </div>
                        </div>

                        <div className="w3-container w3-card w3-white">
                            <h2 className="w3-text-grey w3-padding-16"><i
                                className="fa fa-certificate fa-fw w3-margin-right w3-xxlarge w3-text-teal"></i>Education</h2>

                            <div className="w3-container">
                                <h5 className="w3-opacity"><a href="https://www.facebook.com/aptechlatifabad/"><b>Aptech Pakistan</b></a></h5>
                                <hr />
                                <h6 className="w3-text-teal"><i className="fa fa-calendar fa-fw w3-margin-right"></i>2022 to Stil Learning</h6>
                                <p className="mt-3">Offering diploma courses in Information Technology. Covering Current and in-demand skills</p>
                            </div>
                            <div className="w3-container">
                                <h5 className="w3-opacity"><b>Govt. Degree Collage Dadu</b></h5>
                                <hr />
                                <h6 className="w3-text-teal"><i className="fa fa-calendar fa-fw w3-margin-right"></i>2013 - 2015</h6>
                                <p className="mt-3">Colleges typically focus on providing a well-rounded education that prepares students for a variety of careers, while also fostering personal growth and development. Many colleges offer a range of extracurricular activities, such as sports, clubs, and student organizations, which allow students to pursue their interests outside of the classroom. Additionally, colleges often have resources and facilities, such as libraries, computer labs, and career centers, which students can use to enhance their academic and professional experiences. The goal of most colleges is to provide students with the knowledge, skills, and experiences they need to succeed in their future endeavors.</p>

                            </div>
                            <div className="w3-container">
                                <h5 className="w3-opacity"><b>Yasir Public School Dadu</b></h5>
                                <hr />
                                <h6 className="w3-text-teal"><i className="fa fa-calendar fa-fw w3-margin-right"></i>2010 - 2013</h6>
                                <p className="mt-3">School is an educational institution designed to provide learning spaces and opportunities for students. Schools can range from primary schools that serve young children to universities that offer advanced degrees. Schools typically offer a curriculum that includes subjects such as math, science, language arts, and social studies, as well as elective courses that allow students to explore their interests.

                                    Schools are typically staffed by teachers, administrators, and support staff who work together to create a safe and supportive learning environment for students. They provide students with the resources and guidance they need to succeed academically and personally. In addition to regular classes, schools often offer extracurricular activities, such as sports, music, and clubs, which provide opportunities for students to explore their interests and develop new skills.

                                    The goal of most schools is to help students acquire the knowledge and skills they need to succeed in the future, whether that be in their careers or personal lives. Schools play an important role in shaping students' lives and helping them reach their full potential.</p><br />
                            </div>
                        </div>
                    </div>

                </div>

            </div>


        </div >
    )
}
